<svg id="svg-container-{{uid}}" viewBox="-40 -25 270 173" height="100%"
	xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:cc="http://creativecommons.org/ns#"
	xmlns:dc="http://purl.org/dc/elements/1.1/"
	version="1.1"
	preserveAspectRatio="xMinYMax meet">
	<defs>
		<marker
			id="arrow-{{uid}}"
			viewBox="0 0 10 10"
			refX="5"
			refY="5"
			markerWidth="6"
			markerHeight="6"
			orient="auto-start-reverse">
			<path d="M 0 0 L 10 5 L 0 10 z" />
		</marker>
	</defs>

	{{!-- x-labels --}}
	{{#each x.labels}}
		{{#if ../isHistogram}}
			<text x="{{position}}" class="standardLabel" y="110" font-size="8px" text-anchor="middle">{{value}}</text>
		{{else}}
			<text {{#if rotation}}transform="rotate(-{{rotation}} {{position}} 105)"{{/if}} x="{{position}}" y="108"
				font-size="{{fontSize}}" text-anchor="end"
				class="darker info-{{@index}}" fill="{{color}}">
				{{value}}
			</text>
		{{/if}}
	{{/each}}

	{{!-- y-labels --}}
	{{#each y.labels}}
		<text x="-5" y="{{position}}" font-size="8px" class="standardLabel" dominant-baseline="middle" text-anchor="end">{{value}}</text>
	{{/each}}

	{{!-- bars and x-labels --}}
	{{#each bars}}
		<rect id="rect-{{@index}}-{{../uid}}" x="{{x}}" y="{{y}}" width="{{../barWidth}}" height="{{height}}"
		fill="{{color}}" class="js-chart-bar"></rect>

		{{!-- hoverboxes --}}
		<g id="info-{{@index}}-{{../uid}}" class="hover-info hidden">
			{{#if ../isHistogram}}
				{{!-- x --}}
				<rect rx="5" x="{{CALCULATE info.x.position '-' 5}}" y="100" width="40" height="15px" fill="lightgrey"></rect>
				<text x="{{CALCULATE info.x.position '+' 15}}" y="110" class="standardLabel" font-size="8px" text-anchor="middle">{{{info.x.value}}}</text>
			{{/if}}
			{{!-- y --}}
			<rect rx="5" x="-35" y="{{info.y.position}}" width="30" height="15px" fill="lightgrey"></rect>
			<text x="-20" y="{{y}}" font-size="8px" class="standardLabel" dominant-baseline="middle" text-anchor="middle">
				{{info.y.value}}
			</text>
		</g>
	{{/each}}

	{{!-- x label --}}
	{{#if isHistogram}}
		<text x="200" y="125" font-size="10px" class="standardLabel" text-anchor="end">
			<tspan>{{xLabel}} {{#if x.showBase}}&#183;10{{/if}}</tspan>
			{{#if x.showBase}}{{#COMPARE x.power '!=' 1}}
				{{#if x.showPower}}<tspan dy="-5" dx="-2" font-size="8px" text-anchor="start">{{x.power}}</tspan>{{/if}}
			{{/COMPARE}}
			{{/if}}
		</text>
	{{/if}}

	{{!-- y label --}}
	<text x="-15" y="-20" font-size="10px" dominant-baseline="hanging" class="standardLabel" text-anchor="start">
		<tspan dy="0" dx="0" >{{yLabel}}</tspan>
		{{#if y.showBase}}
			<tspan dy="0" dx="0" >&#183;10</tspan>
			{{#if y.showPower}}<tspan dy="-5" dx="-2" font-size="8px">{{y.power}}</tspan>{{/if}}
		{{/if}}
	</text>

	{{!-- axis --}}
	<line {{#unless isHistogram}}marker-end='url(#arrow-{{uid}})'{{/unless}} x1="0" x2="0" y1="100" y2="0" stroke="black"></line>
	<line {{#unless isHistogram}}marker-end='url(#arrow-{{uid}})'{{/unless}} x1="0" x2="205" y1="100" y2="100" stroke="black"></line>
</svg>

